export function cloneSet<T>(set: Set<T>): Set<T> {
    return new Set<T>(set)
}

export function toggleSet<T>(set: Set<T>, value: T): Set<T> {
    const clone = cloneSet(set)
    if (clone.has(value)) {
        clone.delete(value)
    } else {
        clone.add(value)
    }
    return clone
}
